import * as React from 'react'
function SvgIban(props) {
	return (
		<svg
			width="1em"
			height="1em"
			viewBox="0 0 40 40"
			xmlns="http://www.w3.org/2000/svg"
			{...props}
		>
			<path
				d="M34 4H6a2 2 0 00-2 2v20a2 2 0 002 2h6v8l12-8h10a2 2 0 002-2V6a2 2 0 00-2-2zM24 22H8v-4h16v4zm8 0h-4v-4h4v4z"
				fill="currentColor"
				fillRule="evenodd"
			/>
		</svg>
	)
}
export default SvgIban
